import React from "react";

const RequireField = () => {
  return (
    <span style={{ color: "red", marginLeft: "4px" }}>*</span>
  )
};

export default RequireField;
